import { renderContentMarketing } from '../../components/content-marketing/content-marketing-render';

export function handleContentMarketingFrontpage() {
    renderContentMarketing('contentboard_1', true);
}
